import type { LucideIcon } from "lucide-react";
import type { SectionId } from "../constants";

interface SectionCardProps {
	id: SectionId;
	icon: LucideIcon;
	title: string;
	count: number;
	unit: string;
	caption: string;
	prefix?: string;
	variant: string;
	isActive: boolean;
	onClick: (id: SectionId) => void;
}

export function SectionCard({
	id,
	icon: Icon,
	title,
	count,
	unit,
	caption,
	prefix,
	variant,
	isActive,
	onClick,
}: SectionCardProps) {
	return (
		<button
			type="button"
			className={`today-section today-section--${variant}${isActive ? " today-section--active" : ""}`}
			onClick={() => onClick(id)}
		>
			<span className="today-section__main">
				<span className="today-section__title">{title}</span>
				<span className="today-section__count">
					{prefix && <span className="today-section__prefix">{prefix}</span>}
					<span className="today-section__num">{count}</span>
					<span className="today-section__unit">{unit}</span>
				</span>
				<span className="today-section__caption">{caption}</span>
			</span>
			<span className="today-section__icon" aria-hidden="true">
				<Icon size={24} />
			</span>
		</button>
	);
}
